import { Divider, MenuItem, Popover } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';
import styled from 'styled-components';

const StyledMenuItem = styled(MenuItem)`
  padding: 8px 12px !important;
  height: 42px;
  min-width: 200px;
`;

type ContextualMenuOption = {
  key: string;
  disabled?: boolean;
  text: React.ReactElement;
  onClick: (...args: any[]) => any;
} | null; // null if a Divider must be shown

type ContextualMenuProps = {
  options: ContextualMenuOption[];
  anchorElementPosition: {
    top: number;
    left: number;
  };
  onClose: (...args: any[]) => any;
  styledMenuItemStyles?: React.CSSProperties;
};

export const ContextualMenu = ({
  options,
  anchorElementPosition,
  onClose,
  styledMenuItemStyles,
}: ContextualMenuProps) => {
  return (
    <Popover
      anchorReference="anchorPosition"
      anchorPosition={anchorElementPosition}
      keepMounted
      open={Boolean(anchorElementPosition)}
      onClose={() => onClose()}
      transformOrigin={{
        vertical: `top`,
        horizontal: `left`,
      }}
      slotProps={{
        paper: {
          style: {
            border: `1px solid ${RoutalPalette.neutral10}`,
            backgroundColor: `white`,
            color: `${RoutalPalette.secondary00}`,
            boxShadow: `none`,
          },
        },
      }}
    >
      {options.map((option, idx) => {
        if (option === null) {
          return (
            <MenuItem key={`divider${idx}`} style={{ padding: 0 }}>
              <Divider style={{ width: `100%` }} />
            </MenuItem>
          );
        }

        return (
          <StyledMenuItem
            key={option.key}
            disabled={option.disabled}
            onClick={(ev) => {
              if (option.onClick) {
                option.onClick(ev);
              }
              // onClose();
            }}
            style={styledMenuItemStyles ?? {}}
          >
            {option.text}
          </StyledMenuItem>
        );
      })}
    </Popover>
  );
};
